// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"10e55a5d","71":"d07ccac5","462":"1d31e7a0","501":"e065e47c","735":"6756885b","736":"a4a108d7","841":"b412ddc0","880":"d5a1dc05","883":"91ae0c4f","887":"26177887","983":"955e6a3d"}[chunkId] + ".chunk.js";
};